import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" fill-rule="evenodd" clip-rule="evenodd" d="M56 112C86.9279 112 112 86.9277 112 55.9998C112 25.0718 86.9279 -0.000244141 56 -0.000244141C25.0721 -0.000244141 0 25.0718 0 55.9998C0 86.9277 25.0721 112 56 112Z" fill="#44D058"/>
    <g filter="url(#filter0_d_11381_10855)">
    <circle cx="56" cy="55.9998" r="28" fill="#09BA71"/>
    </g>
    <path d="M61.6718 54.7829L55.2806 61.2787L51.8164 58.1461" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <defs>
    <filter id="filter0_d_11381_10855" x="24" y="25.9998" width="64" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="2"/>
    <feGaussianBlur stdDeviation="2"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0.170288 0 0 0 0 0.231873 0 0 0 0 0.278061 0 0 0 0.124066 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11381_10855"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11381_10855" result="shape"/>
    </filter>
    </defs>
    </svg>

  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;

